<template>
  <div
    class="ui-intro"
    :class="{
      'ui-intro--app' : $inApp,
      'ui-intro--app-with-score' : $inApp && $store.state.userData.score > 0,
      }"
  >
    <div class="ui-intro__content">
      <div class="content__body content__body--intro">
        <p class="content__text" v-html="message"/>

        <ButtonShare
          class="content__share"
          v-if="$inApp && $isLogged && $store.state.userData.score > 0"
        />

        <TableScore
          class="content__table"
          v-if="$inApp && $isLogged && $store.state.userData.scoreRange.length > 0"
        />

        <ButtonRounded
          class="content__button"
          :content="$translate('start')"
          action="pgSelection"
        />
      </div>

    </div>
  </div>
</template>

<script>
import ButtonShare from '@/components/ButtonShare.vue';
import TableScore from '@/components/TableScore.vue';
import ButtonRounded from '@/components/ButtonRounded.vue';

export default {
  name: 'Intro',

  components: {
    ButtonShare,
    TableScore,
    ButtonRounded,
  },

  computed: {
    message() {
      let message;

      switch (true) {
        case this.$inApp && this.$isLogged:
          message = `
            ${this.$translate('welcome').app.firstText} ${this.$store.state.userData.userName} ${this.$translate('welcome').app[this.$store.state.userData.score === 0 ? 'secondText' : 'secondTextRecurrent']}
          `;
          break;

        default:
          message = this.$translate('welcome').noApp;
          break;
      }

      return message;
    },
  },
};
</script>

<style lang="scss" scoped>
.ui-intro {
  pointer-events: auto;

  display: flex;
  align-items: center;
  justify-content: center;

  &.ui-intro--app .ui-intro__content {
    bottom: 10vh;

    .content__body {
      height: 70vh;
    }
  }

  &.ui-intro--app-with-score .ui-intro__content .content__body {
    color: $color-yellow;
  }

  &__content {
    position: absolute;
    width: 100%;
    bottom: 15vh;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column nowrap;

    .content__body {
      height: 60vh;

      display: flex;
      align-items: center;
      justify-content: space-around;
      flex-flow: column nowrap;

      color: $color-yellow;
      text-align: center;
      font-weight: 800;
      @extend %font-medium;
    }
  }
}
</style>
